import Component from 'vue-class-component'
import ContainerVue from './Container'
import { SectionData } from '../../store/editor/components/state'
import { Actions } from '../../store/editor/components/helpers'
import InteractableComponent from './InteractableComponent'
import { EventType } from './Draggable'
import { NORTH, SOUTH } from './Droppable'
import { Watch } from 'vue-property-decorator'
import { INITIAL_COLOR, PREDEFINE_COLORS } from '../constants/ColorPicker'

@Component
export default class SectionVue extends ContainerVue<SectionData> {
  withRange: boolean = false
  backgroundColor: string = INITIAL_COLOR
  predefineColors: string[] = PREDEFINE_COLORS
  clickedColorPicker: boolean = false
  private interactable: InteractableComponent

  get color(): string | undefined {
    const data = this.componentData
    return data.background ? data.background.color : undefined
  }

  mounted(): void {
    // コンポーネントを作成した際に背景色の初期値が履歴に積まれるのを防ぐ
    if (this.color) {
      this.backgroundColor = this.color
    }
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.draggable({
      handle: '.section-handle',
      eventType: EventType.SECTION
    })
    this.interactable.droppable({
      directions: [NORTH, SOUTH],
      eventType: [EventType.DEFAULT, EventType.SECTION]
    })
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
  }

  destroyed(): void {
    this.interactable.destroy()
  }

  showRange(): void {
    this.withRange = true
  }

  hideRange(): void {
    this.withRange = false
  }

  activeColor(val: string): void {
    this.backgroundColor = val
  }

  @Watch('color')
  historyColor(): void {
    this.backgroundColor = this.color ? this.color : INITIAL_COLOR
  }

  clickedColorPickerIcon(): void {
    this.clickedColorPicker = true
  }

  submitColor(color: string): void {
    this.saveColor(color)
    this.clickedColorPicker = false
  }

  // カラーピッカーが閉じたときの処理
  closeColorPicker(): void {
    if (!this.clickedColorPicker) {
      return
    }
    this.clickedColorPicker = false
    this.saveColor(this.backgroundColor)
  }

  saveColor(color: string): void {
    if (!color) {
      color = INITIAL_COLOR
      this.backgroundColor = INITIAL_COLOR
    }
    const data = this.componentData
    this.$nextTick(() => {
      this.save(Object.assign({}, data, {
        background: {
          color
        }
      }))
    })
  }
}
